import { useContext } from 'react';
import { SuccessGamblingContext } from '@/components/success-gambling/context';

export default function useSuccessGamblingContext() {
  const context = useContext(SuccessGamblingContext);
  if (context) {
    return context;
  } else {
    throw new Error('useSuccessGamblingContext must be used within the SuccessGambling');
  }
}
